import{mobileFullWidthColumnClassName as e,mobileNoWrapColumnClassName as t}from"../defaults.js";import{textCssClasses as n}from"../../sections/section-text.js";import"../../types.js";import{getEmailBackgroundColor as r}from"../get-email-background-color.js";import{fixTopSpacingOnMobile as i}from"./css-utils-top-padding.js";import{getAllTextRegions as a}from"./html/get-all-text-regions.js";import{getActualSectionPaddingForSmallScreenCss as o}from"./get-section-padding-tweaks-for-small-screen-css.js";import{getMobileLineHeightClasses as s}from"./get-mobile-line-height-classes.js";import{getMobileFontSizeClasses as c}from"./get-mobile-font-size-classes.js";import{getFooterSectionStyle as l}from"./get-footer-section-style.js";import{getMixCss as u,getMixSmallScreenCss as d,getMobileMixMulticolumnCss as f}from"./get-mix-section-style.js";import{getItemGridSmallScreenCss as p}from"./get-item-grid-section-style.js";import{uniq as m}from"lodash";import{RegionType as h}from"@wix/shoutout-email-model-v3";const{smScreen:g,lgScreen:_,all:v}=l(),y=()=>({smScreen:[o,S,j,C,x],lgScreen:[k],all:[T,E,O,A]}),b=e=>{let t=t=>t.map(t=>t(e)).join(` `),n=e=>m(e.filter(e=>e.type===h.Mix).map(e=>f(e)).join(` `).split(`}`)).join(`}`),{breakPoint:r,sections:a,buildForMobile:o}=e,s=y();m(a.map(e=>e.type)).forEach(e=>{switch(e){case`footer`:s.smScreen.push(...g),s.lgScreen.push(_),s.all.push(v);return;case`follow`:s.smScreen.push(D);return;case`mix`:s.smScreen.push(d),s.all.push(u);return;case`subscribe`:s.smScreen.push(w),s.all.push(M);return;case`item_grid`:s.smScreen.push(p);return;default:return}});let c=i(a),l=``;if(o){let e=n(a);l=`
    @media only screen and (max-width: ${r}) {
      ${t(s.smScreen)}
      ${e}
      .html-email-body-section-topSpacer > div {
        height: 0px!important;
      }
      .first-region-section > table > tbody > tr > td {
        padding-top: ${c.margin}px!important;
      }
      .first-region-section .html-email-body-column > table > tbody > tr > td {
        padding-top: ${c.padding}px!important;
      }
    }

  `}return`${l}

    @media only screen and (min-width: ${r}) {
      ${t(s.lgScreen)}
    }

    ${t(s.all)}
  `};function x(){return`.${e} { max-width: 100%!important; }
    .${t} { max-width: unset!important; }
  `}function S(){return`
    .social-icon { width: 36px!important; height: 36px!important; }
    .social-icon-spacer { width: 12px!important; }
    .social-icon-wrap { margin: 12px!important; }
  `}function C(){return`
    .${n.text} {
      padding: 0!important;
    }
  `}function w(){return`
  .html-emails-subscribe-button {
    padding-top: 15px!important;
  }

  .html-email-body-column.html-emails-subscribe-input-container > table > tbody > tr > td {
    padding-bottom: 0px!important;
  }
  `}function T(){return`
    a, a:visited { text-decoration: none; }
  `}function E(){return`
    a, a:active, a:visited, a:hover, a:link {
      color: #109FFF;
    }
  `}function D(){return`
    .social-follow-element > td {
      padding: 12px!important;
    }
    .social-follow-element img {
      width:36px!important;
      height:36px!important
    }
  `}function O(){return`
    .html-emails-button > table > tbody > tr > td {
      overflow: hidden;
    }
    .html-emails-button > div > table > tbody > tr > td {
      overflow: hidden;
    }
  `}function k(){return`.html-emails-background > tbody > tr > td {padding: 24px 0!important;}`}function A({composerData:e}){return`
    [class="x_html-emails-background"] {
      background-color: ${r(e)}!important;
    }`}function j(e){let{experiments:t,composerData:n,sections:r}=e,i=a(n,r,t);return[c(i,e),s(i,e)].join(` `)}function M(){return`
    .html-emails-subscribe-button-container {
      overflow: hidden;
    }

    .html-emails-subscribe-button p {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  `}export{b as buildGlobalCssWithSectionStyleGenerators,O as getButtonDefaultCss,A as getOutlookBgColor};
//# sourceMappingURL=build-global-css.js.map